import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

import { Orders } from './-components/Orders';
import { SearchSchema } from './-zod-schema';

export const Route = createFileRoute(
  '/_staff/marketplace/_store/store/sent-orders/',
)({
  component: Orders,
  validateSearch: zodValidator(SearchSchema),
});
